import type { PortableTextBlock } from '@portabletext/types';
import type { Footnotes } from 'types/cms/Footnotes';

export { sanityClient as client } from 'lib/sanity/client';
export { useImage } from 'lib/sanity/useImage';

export const getFootnotes = (blocks: PortableTextBlock[]): Array<Footnotes> =>
  blocks
    ?.flatMap((block) => block.markDefs!) // Footnote schema should always have a markDef
    ?.filter((markDef) => markDef?._type === 'timeline_footnote');
